import { createMutation } from '../../libs';
import { FileResponse, FilesResponse } from './models';

export const useFileService = createMutation<FileResponse, FormData>({
  method: 'post',
  url: 'files',
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
export const useFilesService = createMutation<FilesResponse, FormData[]>({
  method: 'post',
  url: 'files/multiple',
});
